// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-z2bw2-MuiStepLabel-label.MuiStepLabel-alternativeLabel
 {
    margin-top: 2pxn!important;
  }
  
.MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
  -webkit-text-fill-color: black !important;
}`, "",{"version":3,"sources":["webpack://./src/components/test/test.css"],"names":[],"mappings":"AAAA;;IAEI,0BAA0B;EAC5B;;AAEF;EACE,yCAAyC;AAC3C","sourcesContent":[".css-z2bw2-MuiStepLabel-label.MuiStepLabel-alternativeLabel\n {\n    margin-top: 2pxn!important;\n  }\n  \n.MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {\n  -webkit-text-fill-color: black !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
